import {
  CCT_WORKLIST_DATA_REQUEST,
  CCT_WORKLIST_DATA_SUCCESS,
  CCT_WORKLIST_DATA_FAILURE,
  CCT_WORKLIST_DD_REQUEST,
  CCT_WORKLIST_DD_SUCCESS,
  CCT_WORKLIST_DD_FAILURE,
  CCT_WORKLIST_FILTER_DROPDOWN_SUCCESS,
  CCT_WORKLIST_FILTER_DROPDOWN_VALUE_SUBMIT,
  CCT_WORKLIST_FILTER_CLEAR,
  CCT_WORKLIST_PAGINATION_TOKEN_CLEAR,
  CCT_WORKLIST_PAGINATION_TOKEN_ADD,
  CCT_WORKLIST_PAGINATION_TOKEN_REMOVE,
  CCT_PAGE_NO_UPDATE,
  CCT_Practice_Id_UPDATE,
  CCT_SELECTED_VALUE_ON_SUBMIT_CLEAR,
  CCT_Provider_Id_UPDATE,
  CCT_WORKLIST_DD_FAILURE_RE_ROUTE,
  CCT_WORKLIST_DD_FAILURE_RE_ROUTE_CLEAR,
  CCT_WORKLIST_CORRUPTED_DATA_REQUEST,
  CCT_WORKLIST_CORRUPTED_DATA_SUCCESS,
} from './types';

const initialState = {
  recordings: {
    isFetching: false,
    data: [],
    error: {},
    dataLastUpdated: new Date(),
  },
  filterDropdownlist: {
    isFetching: false,
    data: [],
    error: {},
  },
  selectedFilterDropdown: '',
  selectedvalueOnSubmit: {},
  paginationToken: [],
  worklistCCTAutoCompleteSearch: {},
  worklistPracticeAutoCompleteSearch: [],
  worklistProviderAutoCompleteSearch: {},
  pageNo: 1,
  practiceId: null,
  providerId: null,
  routedToAnnotationPageError: false,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CCT_WORKLIST_DATA_REQUEST]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: true,
      data: [],
      error: {},
      dataLastUpdated: new Date(),
    },
  }),
  [CCT_WORKLIST_CORRUPTED_DATA_REQUEST]: (state, action) => ({
    ...state,
    recordings: {
      ...state.recordings,
      isFetching: true,
    },
  }),
  [CCT_WORKLIST_CORRUPTED_DATA_SUCCESS]: (state, action) => ({
    ...state,
    recordings: {
      ...state.recordings,
      isFetching: false,
    },
  }),
  [CCT_WORKLIST_DATA_SUCCESS]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: action.payload,
      error: {},
      dataLastUpdated: new Date(),
    },
    worklistCCTAutoCompleteSearch: action.payload.items.map(item => {
      return {
        customParticipantID: item.patient.mrn,
        firstName: item.patient.first_name,
        lastName: item.patient.last_name,
        id: item.patient.id,
      };
    }),
    worklistPracticeAutoCompleteSearch: action.payload.items.map(item => {
      return {
        teamName: item.provider.team_name,
        team_id: item.provider.team_id,
      };
    }),
    worklistProviderAutoCompleteSearch: action.payload.items.map(item => {
      return {
        name: `${item.provider.first_name} ${item.provider.last_name}`,
        member_id: item.provider.member_id,
      };
    }),
  }),
  [CCT_WORKLIST_DATA_FAILURE]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: [],
      error: 'failed',
      dataLastUpdated: new Date(),
    },
  }),
  [CCT_WORKLIST_DD_REQUEST]: (state, action) => ({
    ...state,
    filterDropdownlist: {
      isFetching: true,
      data: [],
      error: {},
    },
  }),
  [CCT_WORKLIST_DD_SUCCESS]: (state, action) => ({
    ...state,
    filterDropdownlist: {
      isFetching: false,
      data: action.payload,
      error: {},
    },
  }),
  [CCT_WORKLIST_DD_FAILURE]: (state, action) => ({
    ...state,
    filterDropdownlist: {
      isFetching: false,
      data: [],
      error: 'failed',
    },
  }),
  [CCT_WORKLIST_FILTER_DROPDOWN_SUCCESS]: (state, action) => ({
    ...state,
    selectedFilterDropdown: action.payload,
  }),
  [CCT_WORKLIST_FILTER_DROPDOWN_VALUE_SUBMIT]: (state, action) => ({
    ...state,
    selectedvalueOnSubmit: action.payload,
  }),
  [CCT_WORKLIST_FILTER_CLEAR]: (state, action) => ({
    ...state,
    selectedFilterDropdown: '',
    selectedvalueOnSubmit: {},
  }),
  [CCT_WORKLIST_PAGINATION_TOKEN_ADD]: (state, action) => ({
    ...state,
    paginationToken: action.payload
      ? [...state.paginationToken, action.payload]
      : [...state.paginationToken],
  }),
  [CCT_WORKLIST_PAGINATION_TOKEN_CLEAR]: (state, action) => ({
    ...state,
    paginationToken: [],
    // selectedvalueOnSubmit: {},
  }),
  [CCT_WORKLIST_PAGINATION_TOKEN_REMOVE]: (state, action) => ({
    ...state,
    paginationToken: [...state.paginationToken.slice(0, -action.payload)],
  }),
  [CCT_PAGE_NO_UPDATE]: (state, action) => ({
    ...state,
    pageNo: action.payload,
  }),
  [CCT_Practice_Id_UPDATE]: (state, action) => ({
    ...state,
    practiceId: action.payload,
  }),
  [CCT_Provider_Id_UPDATE]: (state, action) => ({
    ...state,
    providerId: action.payload,
  }),
  [CCT_SELECTED_VALUE_ON_SUBMIT_CLEAR]: (state, action) => ({
    ...state,
    selectedvalueOnSubmit: {},
  }),
  [CCT_WORKLIST_DD_FAILURE_RE_ROUTE]: (state, action) => ({
    ...state,
    routedToAnnotationPageError: true,
  }),

  [CCT_WORKLIST_DD_FAILURE_RE_ROUTE_CLEAR]: (state, action) => ({
    ...state,
    routedToAnnotationPageError: false,
  }),

  // [CLEAR_STATE]: (state, action) => ({ ...initialState }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxCCTWorklist = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxCCTWorklist/KardiaRxCCTWorklistReducers.js